export const translations = {
    en: {
        ELEVATOR: 'Elevator',
        ESCALATOR: 'Escalator',
        STAIRS: 'Stairs',
        RAMP: 'Ramp',
        UP: 'up',
        DOWN: 'down',
        TO_FLOOR: 'to floor',
        YOU_ARE_HERE: 'You are here',
        IN: 'in',
        METERS: 'meters',
        START: 'Beginning of your journey.',
        DESTINATION: `you'll arrive to your destination.`,
        STRAIGHT: 'continue straight.',
        TURN_AROUND: 'turn around.',
        HARD_LEFT: 'turn hard left.',
        SLIGHT_LEFT: 'turn slight left.',
        LEFT: 'turn left.',
        HARD_RIGHT: 'turn hard right.',
        SLIGHT_RIGHT: 'turn slight right.',
        RIGHT: 'turn right.',
        UP_STAIRCASE: 'go upstairs via staircase.',
        UP_ESCALATOR: 'go upstairs via escalator.',
        UP_ELEVATOR: 'go upstairs via elevator.',
        UP_RAMP: 'go upstairs via ramp.',
        DOWN_STAIRCASE: 'go downstairs via staircase.',
        DOWN_ESCALATOR: 'go downstairs via escalator.',
        DOWN_ELEVATOR: 'go downstairs via elevator.',
        DOWN_RAMP: 'go downstairs via ramp.',
        EXIT_STAIRCASE: 'Exit via staircase.',
        EXIT_ESCALATOR: 'Exit via escalator.',
        EXIT_ELEVATOR: 'Exit via elevator.',
        EXIT_RAMP: 'Exit via ramp.',
        CONTINUE: 'continue.',
        TO: 'to',
        FLOOR: 'floor',
        BY: 'by',
        IS_ON_YOUR: 'is on your',
    },
    fi: {
        ELEVATOR: 'Hissi',
        ESCALATOR: 'Liukuportaat',
        STAIRS: 'Portaat',
        RAMP: 'Luiska',
        UP: 'ylös',
        DOWN: 'alas',
        TO_FLOOR: 'kerrokseen',
        YOU_ARE_HERE: 'Olet täällä',
        IN: 'sisään',
        METERS: 'metriä',
        START: 'Matkasi alku.',
        DESTINATION: 'saavut määränpäähäsi.',
        STRAIGHT: 'jatka suoraan.',
        TURN_AROUND: 'käänny ympäri.',
        HARD_LEFT: 'käänny jyrkästi vasemmalle.',
        SLIGHT_LEFT: 'käänny hieman vasemmalle.',
        LEFT: 'käänny vasemmalle.',
        HARD_RIGHT: 'käänny jyrkästi oikealle.',
        SLIGHT_RIGHT: 'käänny hieman oikealle.',
        RIGHT: 'käänny oikealle.',
        UP_STAIRCASE: 'mene ylös portaita.',
        UP_ESCALATOR: 'mene ylös liukuportailla.',
        UP_ELEVATOR: 'mene ylös hissillä.',
        UP_RAMP: 'mene ylös luiskalla.',
        DOWN_STAIRCASE: 'mene alas portaita.',
        DOWN_ESCALATOR: 'mene alas liukuportailla.',
        DOWN_ELEVATOR: 'mene alas hissillä.',
        DOWN_RAMP: 'mene alas luiskalla.',
        EXIT_STAIRCASE: 'Poistu portaita.',
        EXIT_ESCALATOR: 'Poistu liukuportailla.',
        EXIT_ELEVATOR: 'Poistu hissillä.',
        EXIT_RAMP: 'Poistu luiskalla.',
        CONTINUE: 'jatka.',
        TO: 'osoitteeseen',
        FLOOR: 'lattia',
        BY: 'liikkeellä',
        IS_ON_YOUR: 'on sinun',
    },
    ar: {
        ELEVATOR: 'المصعد',
        ESCALATOR: 'السلم الكهربائي',
        STAIRS: 'الدرج',
        RAMP: 'المنحدر',
        UP: 'صعوداً',
        DOWN: 'هبوطاً',
        TO_FLOOR: 'إلى الطابق',
        YOU_ARE_HERE: 'أنت هنا',
        IN: 'في',
        METERS: 'أمتار',
        START: 'بداية رحلتك.',
        DESTINATION: 'ستصل إلى وجهتك.',
        STRAIGHT: 'تابع السير مباشرة.',
        TURN_AROUND: 'استدر للخلف.',
        HARD_LEFT: 'انعطف بحدة إلى اليسار.',
        SLIGHT_LEFT: 'انعطف قليلاً إلى اليسار.',
        LEFT: 'انعطف إلى اليسار.',
        HARD_RIGHT: 'انعطف بحدة إلى اليمين.',
        SLIGHT_RIGHT: 'انعطف قليلاً إلى اليمين.',
        RIGHT: 'انعطف إلى اليمين.',
        UP_STAIRCASE: 'اصعد عبر الدرج.',
        UP_ESCALATOR: 'اصعد عبر السلم الكهربائي.',
        UP_ELEVATOR: 'اصعد بالمصعد.',
        UP_RAMP: 'اصعد عبر المنحدر.',
        DOWN_STAIRCASE: 'انزل عبر الدرج.',
        DOWN_ESCALATOR: 'انزل عبر السلم الكهربائي.',
        DOWN_ELEVATOR: 'انزل بالمصعد.',
        DOWN_RAMP: 'انزل عبر المنحدر.',
        EXIT_STAIRCASE: 'اخرج عبر الدرج.',
        EXIT_ESCALATOR: 'اخرج عبر السلم الكهربائي.',
        EXIT_ELEVATOR: 'اخرج بالمصعد.',
        EXIT_RAMP: 'اخرج عبر المنحدر.',
        CONTINUE: 'تابع.',
        TO: 'إلى',
        FLOOR: 'الطابق',
        BY: 'بواسطة',
        IS_ON_YOUR: 'في',
    },
    it: {
        ELEVATOR: 'Ascensore',
        ESCALATOR: 'Scala mobile',
        STAIRS: 'Scale',
        RAMP: 'Rampa',
        UP: 'su',
        DOWN: 'giù',
        TO_FLOOR: 'al piano',
        YOU_ARE_HERE: 'Tu sei qui',
        IN: 'in',
        METERS: 'metri',
        START: 'Inizio del tuo viaggio.',
        DESTINATION: 'arriverai alla tua destinazione.',
        STRAIGHT: 'continua dritto.',
        TURN_AROUND: 'girati.',
        HARD_LEFT: 'gira bruscamente a sinistra.',
        SLIGHT_LEFT: 'gira leggermente a sinistra.',
        LEFT: 'gira a sinistra.',
        HARD_RIGHT: 'gira bruscamente a destra.',
        SLIGHT_RIGHT: 'gira leggermente a destra.',
        RIGHT: 'gira a destra.',
        UP_STAIRCASE: 'sali le scale.',
        UP_ESCALATOR: 'sali con la scala mobile.',
        UP_ELEVATOR: 'sali con l’ascensore.',
        UP_RAMP: 'sali con la rampa.',
        DOWN_STAIRCASE: 'scendi le scale.',
        DOWN_ESCALATOR: 'scendi con la scala mobile.',
        DOWN_ELEVATOR: 'scendi con l’ascensore.',
        DOWN_RAMP: 'scendi con la rampa.',
        EXIT_STAIRCASE: 'Esci tramite le scale.',
        EXIT_ESCALATOR: 'Esci con la scala mobile.',
        EXIT_ELEVATOR: 'Esci con l’ascensore.',
        EXIT_RAMP: 'Esci con la rampa.',
        CONTINUE: 'continua.',
        TO: 'al',
        FLOOR: 'piano',
        BY: 'per',
        IS_ON_YOUR: 'su',
    },
    id: {
        ELEVATOR: 'Lift',
        ESCALATOR: 'Eskalator',
        STAIRS: 'Tangga',
        RAMP: 'Jalur landai',
        UP: 'naik',
        DOWN: 'turun',
        TO_FLOOR: 'ke lantai',
        YOU_ARE_HERE: 'Anda di sini',
        IN: 'di',
        METERS: 'meter',
        START: 'Awal perjalanan Anda.',
        DESTINATION: 'Anda akan tiba di tujuan Anda.',
        STRAIGHT: 'lanjutkan lurus.',
        TURN_AROUND: 'berbalik arah.',
        HARD_LEFT: 'belok kiri tajam.',
        SLIGHT_LEFT: 'belok kiri sedikit.',
        LEFT: 'belok kiri.',
        HARD_RIGHT: 'belok kanan tajam.',
        SLIGHT_RIGHT: 'belok kanan sedikit.',
        RIGHT: 'belok kanan.',
        UP_STAIRCASE: 'naik tangga.',
        UP_ESCALATOR: 'naik eskalator.',
        UP_ELEVATOR: 'naik lift.',
        UP_RAMP: 'naik jalur landai.',
        DOWN_STAIRCASE: 'turun tangga.',
        DOWN_ESCALATOR: 'turun eskalator.',
        DOWN_ELEVATOR: 'turun lift.',
        DOWN_RAMP: 'turun jalur landai.',
        EXIT_STAIRCASE: 'Keluar melalui tangga.',
        EXIT_ESCALATOR: 'Keluar melalui eskalator.',
        EXIT_ELEVATOR: 'Keluar melalui lift.',
        EXIT_RAMP: 'Keluar melalui jalur landai.',
        CONTINUE: 'lanjutkan.',
        TO: 'ke',
        FLOOR: 'lantai',
        BY: 'oleh',
        IS_ON_YOUR: 'di',
    },
    zh: {
        ELEVATOR: '电梯',
        ESCALATOR: '自动扶梯',
        STAIRS: '楼梯',
        RAMP: '坡道 ',
        UP: '向上',
        DOWN: '向下',
        TO_FLOOR: '到楼层',
        YOU_ARE_HERE: '你在这里',
        IN: '进入',
        METERS: '米',
        START: '旅程开始',
        DESTINATION: `你将到达目的地 `,
        STRAIGHT: '继续直行',
        TURN_AROUND: '转身',
        HARD_LEFT: '向左急转',
        SLIGHT_LEFT: '稍微向左转',
        LEFT: '向左转',
        HARD_RIGHT: '向右急转',
        SLIGHT_RIGHT: '稍微向右转',
        RIGHT: '向右转 ',
        UP_STAIRCASE: '通过楼梯上楼',
        UP_ESCALATOR: '通过自动扶梯上楼',
        UP_ELEVATOR: '通过电梯上楼',
        UP_RAMP: '通过坡道上楼',
        DOWN_STAIRCASE: '通过楼梯下楼',
        DOWN_ESCALATOR: ' 通过自动扶梯下楼',
        DOWN_ELEVATOR: '通过电梯下楼',
        DOWN_RAMP: '通过坡道下楼',
        EXIT_STAIRCASE: '通过楼梯出口',
        EXIT_ESCALATOR: '通过自动扶梯出口',
        EXIT_ELEVATOR: '通过电梯出口',
        EXIT_RAMP: '通过坡道出口 ',
        CONTINUE: '继续',
        TO: '到 ',
        FLOOR: '楼层',
        BY: '通过',
        IS_ON_YOUR: '在',
    },
    ru: {
        ELEVATOR: 'Лифт',
        ESCALATOR: 'Эскалатор',
        STAIRS: 'Лестницы',
        RAMP: 'Рамп',
        UP: 'вверх',
        DOWN: 'вниз',
        TO_FLOOR: 'на пол',
        YOU_ARE_HERE: 'Вы здесь',
        IN: 'в',
        METERS: 'метров',
        START: 'Начало вашего путешествия',
        DESTINATION: `Вы прибудете в пункт назначения.`,
        STRAIGHT: 'продолжить движение прямо',
        TURN_AROUND: 'развернуться',
        HARD_LEFT: 'повернуть налево',
        SLIGHT_LEFT: 'повернуть немного налево',
        LEFT: 'повернуть налево',
        HARD_RIGHT: 'повернуть сильно вправо',
        SLIGHT_RIGHT: 'повернуть немного вправо',
        RIGHT: 'повернуть направо',
        UP_STAIRCASE: 'подняться наверх по лестнице',
        UP_ESCALATOR: 'подняться наверх на эскалаторе',
        UP_ELEVATOR: 'подняться наверх на лифте',
        UP_RAMP: 'подняться наверх по пандусу',
        DOWN_STAIRCASE: 'спуститься вниз по лестнице',
        DOWN_ESCALATOR: 'спуститься вниз на эскалаторе',
        DOWN_ELEVATOR: 'спуститься вниз на лифте',
        DOWN_RAMP: '  Спуститься вниз по пандусу',
        EXIT_STAIRCASE: '  Выход по лестнице',
        EXIT_ESCALATOR: ' Выход через эскалатор',
        EXIT_ELEVATOR: '  Выход через лифт',
        EXIT_RAMP: 'Выход через рампу',
        CONTINUE: 'продолжать',
        TO: 'к',
        FLOOR: 'пол',
        BY: 'по',
        IS_ON_YOUR: 'на',
    },
};
